import React, { createContext, useContext, useState, useCallback, useEffect } from "react";

const CompareContext = createContext(null);
const KEY = "ico_compare_ids";

export function CompareProvider({ children }) {
  const [ids, setIds] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(ids));
  }, [ids]);

  const toggle = useCallback((id) => {
    setIds((prev) => (prev.includes(id) ? prev.filter((x) => x !== id) : prev.length >= 6 ? prev : [...prev, id]));
  }, []);
  const remove = useCallback((id) => setIds((prev) => prev.filter((x) => x !== id)), []);
  const clear = useCallback(() => setIds([]), []);
  const add = useCallback((id) => setIds((prev) => (prev.includes(id) ? prev : prev.length >= 6 ? prev : [...prev, id])), []);

  return (
    <CompareContext.Provider value={{ ids, toggle, remove, clear, add }}>
      {children}
    </CompareContext.Provider>
  );
}

export function useCompare() {
  return useContext(CompareContext);
}
